import React from 'react';
import { CircularProgress } from '@mui/material';

const ButtonLoading = ({ color = 'primary' }) => (
  <CircularProgress
    color={color}
    style={{
      height: '27px',
      width: '27px',
    }}
  />
);

export default ButtonLoading;
